// Dear A, cookies / Purple Social Club theme scripts. Everything works without JS except
// the quick add, drawer and box builder, which need it by nature.

// ---------------------------------------------------------------- reveal
(function () {
  var items = document.querySelectorAll('.reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  items.forEach(function (el) { io.observe(el); });
})();

// ---------------------------------------------------------------- opening
// Remember it played this visit; any click or key skips it.
(function () {
  var root = document.documentElement;
  var el = document.querySelector('[data-intro]');
  if (!el || !root.classList.contains('has-intro')) return;
  function done() {
    root.classList.remove('has-intro');
    try { sessionStorage.setItem('da-intro', '1'); } catch (e) {}
  }
  var timer = setTimeout(done, 4900);
  function skip() { clearTimeout(timer); done(); }
  el.addEventListener('click', skip);
  document.addEventListener('keydown', skip, { once: true });
})();

// ---------------------------------------------------------------- cart
(function () {
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: drawer.dataset.currency || 'GBP' });
  var body = drawer.querySelector('[data-drawer-body]');
  var foot = drawer.querySelector('[data-drawer-foot]');
  var totalEl = drawer.querySelector('[data-drawer-total]');
  var emptyText = drawer.querySelector('[data-empty-text]').content.textContent.trim();
  var lastFocus = null;

  function money(cents) { return fmt.format(cents / 100); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function props(item) {
    var p = item.properties || {};
    var out = Object.keys(p).filter(function (k) { return k.charAt(0) !== '_' && p[k] !== '' && p[k] != null; })
      .map(function (k) { return esc(k) + ' &times; ' + esc(p[k]); });
    return out.length ? '<div class="dl__meta">' + out.join('<br>') + '</div>' : '';
  }

  function render(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer__empty"><img src="' + esc(drawer.dataset.emptyImg || '') + '" alt="" width="220"><p>' + esc(emptyText) + '</p></div>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="dl__meta">' + esc(item.variant_title) + '</div>' : '';
      var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" width="76" height="95">' : '<span></span>';
      return '<div class="dl" data-key="' + esc(item.key) + '">' + img +
        '<div><div class="dl__title">' + esc(item.product_title) + '</div>' + variant + props(item) +
        '<div class="dl__qty"><button type="button" data-qty="-1" aria-label="-">&minus;</button><span>' + item.quantity + '</span><button type="button" data-qty="1" aria-label="+">+</button></div></div>' +
        '<div class="dl__price">' + money(item.final_line_price) + '</div></div>';
    }).join('');
    totalEl.textContent = money(cart.total_price);
    foot.hidden = false;
  }

  function getCart() { return fetch(routes + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function open() {
    lastFocus = document.activeElement;
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    var x = drawer.querySelector('.drawer__x'); if (x) setTimeout(function () { x.focus(); }, 80);
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function add(items) {
    if (drawer.dataset.paused === 'true') return Promise.reject(new Error('paused'));
    return fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(getCart).then(function (cart) {
      render(cart);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      });
      open();
      return cart;
    });
  }

  function change(key, qty) {
    return fetch(routes + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  window.DA = { add: add, open: open, close: close, money: money };

  // header cart link opens the drawer
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); getCart().then(render).then(open); return; }
    if (e.target.closest('[data-drawer-close]')) { close(); return; }
    var q = e.target.closest('.dl [data-qty]');
    if (q) {
      var line = q.closest('.dl');
      var current = parseInt(line.querySelector('.dl__qty span').textContent, 10);
      change(line.dataset.key, Math.max(0, current + parseInt(q.dataset.qty, 10)));
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  getCart().then(render).catch(function () {});

  // ----------------------------------------------------- product cards
  function busy(btn, state) {
    if (!btn.dataset.label) return;
    btn.textContent = btn.dataset[state === 'busy' ? 'labelBusy' : state === 'done' ? 'labelDone' : 'label'];
    btn.disabled = state === 'busy';
  }
  function flash(btn) {
    busy(btn, 'done');
    setTimeout(function () { busy(btn, 'idle'); }, 1400);
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-card] .chip');
    if (chip && !chip.disabled) {
      var card = chip.closest('[data-card]');
      card.querySelectorAll('.chip').forEach(function (c) { c.setAttribute('aria-checked', c === chip ? 'true' : 'false'); });
      card.dataset.variant = chip.dataset.variantId;
      var price = card.querySelector('[data-card-price]');
      price.textContent = chip.dataset.price;
      price.classList.remove('swap'); void price.offsetWidth; price.classList.add('swap');
      return;
    }
    var addBtn = e.target.closest('[data-card-add]');
    if (addBtn) {
      var c = addBtn.closest('[data-card]');
      busy(addBtn, 'busy');
      add([{ id: parseInt(c.dataset.variant, 10), quantity: 1 }])
        .then(function () { flash(addBtn); })
        .catch(function () { busy(addBtn, 'idle'); });
    }
  });

  // product page form adds without leaving the page
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var data = new FormData(form);
      var id = parseInt(data.get('id'), 10);
      if (!id) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      if (btn) btn.disabled = true;
      add([{ id: id, quantity: parseInt(data.get('quantity') || 1, 10) }])
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    });
  });

  // ----------------------------------------------------- create your own box
  document.querySelectorAll('[data-box]').forEach(function (box) {
    var sizes = Array.prototype.slice.call(box.querySelectorAll('[data-size-id]'));
    var flavours = Array.prototype.slice.call(box.querySelectorAll('[data-flavour]'));
    var slots = box.querySelector('[data-slots]');
    var picked = box.querySelector('[data-picked]');
    var totalEl = box.querySelector('[data-total]');
    var priceEl = box.querySelector('[data-price]');
    var addBtn = box.querySelector('[data-box-add]');
    var size = sizes.find(function (s) { return s.getAttribute('aria-checked') === 'true'; }) || sizes[0];
    var counts = flavours.map(function () { return 0; });

    function total() { return counts.reduce(function (a, b) { return a + b; }, 0); }
    function limit() { return parseInt(size.dataset.count, 10); }

    function update() {
      var n = limit(), t = total();
      totalEl.textContent = n;
      picked.textContent = t;
      priceEl.textContent = money(parseInt(size.dataset.cents, 10));
      flavours.forEach(function (f, i) {
        f.querySelector('[data-qty]').textContent = counts[i];
        f.querySelector('[data-less]').disabled = counts[i] === 0;
        f.querySelector('[data-more]').disabled = t >= n;
      });
      // slots: one per cookie, filled in the order chosen
      var seq = [];
      counts.forEach(function (c, i) { for (var k = 0; k < c; k++) seq.push(flavours[i].dataset.image); });
      var html = '';
      for (var s = 0; s < n; s++) {
        html += seq[s] ? '<span class="slot is-filled"><img src="' + esc(seq[s]) + '" alt=""></span>' : '<span class="slot"></span>';
      }
      slots.innerHTML = html;
      addBtn.disabled = t !== n;
    }

    sizes.forEach(function (s) {
      s.addEventListener('click', function () {
        if (s.disabled) return;
        sizes.forEach(function (o) { o.setAttribute('aria-checked', o === s ? 'true' : 'false'); });
        size = s;
        // trim the mix if the box got smaller
        var over = total() - limit();
        for (var i = counts.length - 1; over > 0 && i >= 0; i--) { var take = Math.min(counts[i], over); counts[i] -= take; over -= take; }
        update();
      });
    });
    flavours.forEach(function (f, i) {
      f.querySelector('[data-more]').addEventListener('click', function () { if (total() < limit()) { counts[i]++; update(); } });
      f.querySelector('[data-less]').addEventListener('click', function () { if (counts[i] > 0) { counts[i]--; update(); } });
    });

    addBtn.addEventListener('click', function () {
      if (total() !== limit()) return;
      var properties = {};
      flavours.forEach(function (f, i) { if (counts[i]) properties[f.dataset.name] = counts[i]; });
      addBtn.disabled = true; addBtn.textContent = addBtn.dataset.labelBusy;
      add([{ id: parseInt(size.dataset.sizeId, 10), quantity: 1, properties: properties }])
        .then(function () {
          addBtn.textContent = addBtn.dataset.labelDone;
          counts = flavours.map(function () { return 0; });
          setTimeout(function () { addBtn.textContent = addBtn.dataset.label; update(); }, 1400);
        })
        .catch(function () { addBtn.textContent = addBtn.dataset.label; update(); });
    });

    update();
  });
})();


// ---------------------------------------------------------------- quiet interaction
// Stickers drift with the cursor; cookie photos tilt a few degrees. Fine pointers only.
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !matchMedia('(pointer: fine)').matches) return;

  var hero = document.querySelector('.psc-hero');
  if (hero) {
    var stickers = hero.querySelectorAll('.psc-sticker');
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      stickers.forEach(function (s, i) {
        var depth = (i % 2 ? 1 : -1) * (14 + i * 8);
        s.style.setProperty('--px', (x * depth).toFixed(1) + 'px');
        s.style.setProperty('--py', (y * depth).toFixed(1) + 'px');
      });
    });
  }

  document.addEventListener('pointermove', function (e) {
    var media = e.target.closest && e.target.closest('.card__media');
    if (!media) return;
    var img = media.querySelector('img'); if (!img) return;
    var r = media.getBoundingClientRect();
    img.style.setProperty('--ry', (((e.clientX - r.left) / r.width - 0.5) * 7).toFixed(2) + 'deg');
    img.style.setProperty('--rx', (((e.clientY - r.top) / r.height - 0.5) * -7).toFixed(2) + 'deg');
  });
  document.addEventListener('pointerout', function (e) {
    var media = e.target.closest && e.target.closest('.card__media');
    if (!media) return;
    var img = media.querySelector('img'); if (!img) return;
    img.style.setProperty('--rx', '0deg'); img.style.setProperty('--ry', '0deg');
  });
})();


// ---------------------------------------------------------------- header logo on the Dear A, home
// The big logo in the hero is the logo at the top; the header logo fades in once you scroll past it.
(function () {
  var header = document.querySelector('[data-header].header--home');
  if (!header) return;
  header.classList.add('is-armed');
  function check() { header.classList.toggle('is-scrolled', window.scrollY > 180); }
  check();
  window.addEventListener('scroll', check, { passive: true });
})();


// ---------------------------------------------------------------- welcome offer
// Appears once, a few seconds in and only after the cookie banner is gone. Email -> signed up -> code.
(function () {
  var box = document.querySelector('[data-welcome]');
  if (!box) return;
  var KEY = 'da-welcome';
  try { var seen = JSON.parse(localStorage.getItem(KEY) || 'null'); if (seen && (seen.done || seen.until > Date.now())) return; } catch (e) {}
  function remember(done) { try { localStorage.setItem(KEY, JSON.stringify(done ? { done: true } : { until: Date.now() + 14 * 864e5 })); } catch (e) {} }
  function show() { box.hidden = false; requestAnimationFrame(function () { box.classList.add('is-in'); }); }
  function hide() { box.classList.remove('is-in'); setTimeout(function () { box.hidden = true; }, 700); }
  var waited = 0;
  var timer = setInterval(function () {
    waited += 1000;
    var banner = document.getElementById('shopify-pc__banner');
    if (waited >= 6000 && (!banner || banner.offsetParent === null || waited >= 40000)) { clearInterval(timer); show(); }
  }, 1000);
  box.querySelector('[data-welcome-close]').addEventListener('click', function () { remember(false); hide(); });
  var form = box.querySelector('form');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]'); btn.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('x'); box.querySelector('[data-welcome-form]').hidden = true; box.querySelector('[data-welcome-done]').hidden = false; remember(true); })
      .catch(function () { btn.disabled = false; form.submit(); });
  });
})();
